import * as React from "react";
import {
  ResponsiveContainer,
  Tooltip,
  BarChart,
  CartesianGrid,
  Brush,
  Bar,
  XAxis,
  YAxis,
} from "recharts";
import { ICaseType } from "../types";
import { CustomTooltip } from "../../../../share/components/CustomTooltip/CustomTooltip";
export interface ICaseChartS {}
export interface ICaseChart {
  data: ICaseType[];
}

const COLORS = [
  "#8DD1E1",
  "#82CA9D",
  "#A4DE6C",
  "#8884D8",
  "#83A6ED",
  "#D0ED57",
  "#DCAD00",
  "#FFC658",
  "#FF8042",
  "#00C49F",
  "#B7B5E8",
];
export class CaseTypeChart extends React.Component<ICaseChart, ICaseChartS> {
  constructor(props: ICaseChart) {
    super(props);
  }

  public render() {
    const data = this.props.data
      .filter((stat) => stat.count > 0)
      .map((e: any, index) => {
        e.fill = COLORS[index];
        return e;
      });
    if (!data.length) {
      return <p>No Data to Show</p>;
    }
    return (
      <ResponsiveContainer width={"95%"} height={310}>
        <BarChart syncId="caseTypeChart" width={730} height={250} data={data}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip content={<CustomTooltip />} />
          <Bar dataKey="count" fill="#82ca9d" />
          <Brush dataKey="name" height={30} stroke="#8884d8" />
        </BarChart>
      </ResponsiveContainer>
    );
  }
}

export default CaseTypeChart;
